import { useSyncExternalStore } from "react";

// ---- coarse-pointer detection: "is this a touch-first device" ----------------------------------------------

function subscribePointer(callback: () => void): () => void {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
  const mq = window.matchMedia("(pointer: coarse)");
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
}

function readPointer(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(pointer: coarse)").matches;
}

/**
 * True on touch-first devices. Media-query based, NOT viewport width, and that split is the point: a narrow
 * desktop window is still driven by a mouse (it wants hover affordances and buttons), and a wide tablet is still
 * driven by a finger (it wants the system picker, press-and-hold). Width says which LAYOUT; this says which INPUT.
 * Shared by `Picker` (native wheel vs custom listbox) and the chat's message actions (hold vs the `…` button).
 */
export function useCoarsePointer(): boolean {
  return useSyncExternalStore(subscribePointer, readPointer, () => false);
}
